export const environment = {
  production: true,
  apiRoot: `https://api.financeiro.parleite.app/`,
  tenant: 'APCBRH_PR_CWB'
};
